var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _c("prepare-med-form"),
      _c(
        "div",
        { staticClass: "flex flex-col" },
        [_vm._m(0), _c("prepare-med-list")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("div", { staticClass: "label" }, [_vm._v("清单")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }